import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import LocaleComponent from '../../../../LocaleComponent';
import {publisherFormatter, statusFormatter, percentageFormatter} from '../../../Formatter';
import SearchBox from '../../../../components/SearchBox';
import FilterDropDown from '../../../../components/FilterDropDown';
import downloadCSV from '../../../../libs/donwloadCSV';

class Settings extends LocaleComponent {
  static propTypes = {
    schedule_settings: PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.state = {
      tab: 'settings',
      loaded: false,
      settings: [],
      params: {
        mcId: '',
        typeFilter: this._all,
        statusFilter: this._all,
        publisherFilter: this._all,
        searchText: '',
      },
      availableTypes: [this._all],
      availableStatuses: [this._all],
      availablePublishers: [this._all],
      filteredData: [],
      modal: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    const { settings, location } = nextProps;
    const params = this.parseParams(location.search);

    if (settings && this.state.loaded) {
      this.load(params, {settings, loaded: true})
    }
  }

  componentDidMount() {
    const newParams = this.checkParams();

    if (newParams) {
      this.mergeParams(newParams);
    }

    const { settings } = this.props;
    if (settings) {
      this.load({}, {settings})
    }
  }

  onTypeFilterClick = typeFilter => {
    const path = this.stringfyWithNew({ typeFilter });
    this.props.history.replace(path);
    this.load({ typeFilter });
  };

  onStatusFilterClick = statusFilter => {
    const path = this.stringfyWithNew({ statusFilter });
    this.props.history.replace(path);
    this.load({ statusFilter });
  };

  onPublisherFilterClick = publisherFilter => {
    const path = this.stringfyWithNew({ publisherFilter });
    this.props.history.replace(path);
    this.load({ publisherFilter });
  };

  onSearchTextChanged = (e) => {
    const searchText = e.target.value;
    const path = this.stringfyWithNew({ searchText });
    this.props.history.replace(path);
    this.load({ searchText });
  };

  onDownloadClick() {
    const { filteredData } = this.state;

    if (!downloadCSV('campaign_setting.csv', filteredData)) {
      this.setState({ modal: true });
    }
  }

  load(newParam, newState) {
    const { settings } = this.mergeValues(this.state, newState);
    const { searchText, typeFilter, statusFilter, publisherFilter } = this.mergeValues(this.state.params, newParam);

    const availableTypes = [this._all];
    const availableStatuses = [this._all];
    const availablePublishers = [this._all];

    this.props.setSpin(true);

    settings.forEach(item => {
      if (item.Type !== '' && availableTypes.indexOf(item.Type) === -1) {
        availableTypes.push(item.Type)
      }
      if (item.status !== '' && availableStatuses.indexOf(item.status) === -1) {
        availableStatuses.push(item.status)
      }
      if (item.Publisher !== '' && availablePublishers.indexOf(item.Publisher) === -1) {
        availablePublishers.push(item.Publisher)
      }
    });

    const filteredData = settings.filter(item => {
      return (
          (typeFilter !== this._all) ?
            (item.Type.toString() === typeFilter) : true
        ) && (
          (statusFilter !== this._all) ?
            (item.status.toString() === statusFilter) : true
        ) && (
          (publisherFilter !== this._all) ?
            (item.Publisher.toString() === publisherFilter) : true
        ) && (
          (searchText !== '') ?
            (item.Campaign) ?
              (item.Campaign.indexOf(searchText) !== -1) : false
            : true
        );
    });

    const updatedStates = Object.assign({},
      {
        availableTypes,
        availableStatuses,
        availablePublishers,
        filteredData,
      },
      newState,
      {
        params: this.mergeValues(this.state.params, newParam)
      });

    this.setState(updatedStates);

    this.props.setSpin(false);
  }

  render() {
    const {
      availableTypes,
      availableStatuses,
      availablePublishers,
      filteredData,
      params,
    } = this.state;
    const {
      searchText,
      typeFilter,
      statusFilter,
      publisherFilter,
    } = params;

    const filterBox = (
      <div className="form-group">
        <div className="input-group">
          <div className="input-group-btn">
            <span className="input-group-addon">
              <i className="fa fa-filter" /> &nbsp;
              {this.localeMessage('Filter')}
            </span>
            <FilterDropDown title={this.localeMessage('Publisher')}
                            data={availablePublishers}
                            filter={publisherFilter}
                            onClick={this.onPublisherFilterClick}
            />
            <FilterDropDown title={this.localeMessage('Type')}
                            data={availableTypes}
                            filter={typeFilter}
                            onClick={this.onTypeFilterClick}
            />
            <FilterDropDown title={this.localeMessage('Status')}
                            data={availableStatuses}
                            filter={statusFilter}
                            onClick={this.onStatusFilterClick}
            />
          </div>
        </div>
      </div>
    );

    const DataTable = (props) => {
      const itemCount = props.data.length;

      const renderPaginationPanel = (props) => {
        return (
          <div style={{margin: '20px'}}>
            <div>{ props.components.pageList }</div>
            <div>
              <span>{this.localeMessage('Change size per page')}: </span>
              { props.components.sizePerPageDropdown }
              <span>&nbsp; {props.pageStartIndex} of {itemCount}</span>
            </div>
          </div>
        );
      };

      const pagination = itemCount > 10;
      const options = pagination ? {
        paginationPanel: renderPaginationPanel,
        sizePerPageList: [
          { text: '50', value: 50 },
          { text: '100', value: 100 },
          { text: '200', value: 200 },
          { text: 'All', value: itemCount} ],
        sizePerPage: 50,
      } : {};

      return (
        <BootstrapTable data={props.data} options={options} pagination={pagination}>
          <TableHeaderColumn width='50' dataField={'Publisher'} dataFormat={publisherFormatter} />
          <TableHeaderColumn dataField={'idAccount'} isKey hidden>
            {this.localeMessage('Account ID')}
          </TableHeaderColumn>
          <TableHeaderColumn width='500' dataField={'Campaign'}>
            {this.localeMessage('Campaign')}
          </TableHeaderColumn>
          <TableHeaderColumn dataField={'Type'}>
            {this.localeMessage('TYPE')}
          </TableHeaderColumn>
          <TableHeaderColumn dataField={'Description'}>
            {this.localeMessage('Setting')}
          </TableHeaderColumn>
          <TableHeaderColumn dataField={'Bid'} dataFormat={percentageFormatter}>
            {this.localeMessage('Bid')}
          </TableHeaderColumn>
          <TableHeaderColumn width='150' dataField={'status'} dataFormat={statusFormatter}>
            {this.localeMessage('Status')}
          </TableHeaderColumn>
        </BootstrapTable>
      );
    };

    return (
      <div>
        <div className="row">
          <div className="col-lg-3">
            <SearchBox title={this.localeMessage('Search')}
                       searchText={searchText} onSearchTextChanged={this.onSearchTextChanged}/>
          </div>
          <div className="col-lg-7">
            {filterBox}
          </div>
          <div className="col-lg-2">
            <button type="button" className="btn btn-default btn-sm" onClick={() => this.onDownloadClick()}>
              <i className="fa fa-download" />&nbsp; {this.localeMessage('Download')}
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DataTable data={filteredData}/>
          </div>
        </div>
      </div>
    );
  }
}

export default Settings;




// WEBPACK FOOTER //
// ./src/views/Campaigns/Tabs/Settings/Settings.js